const e = {
  name: "ArrowCircleLeftFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM13.4141 8.00003L11.9999 6.58582L6.58569 12L11.9999 17.4142L13.4141 16L10.4141 13H17.0001V11H10.4142L13.4141 8.00003Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as ArrowCircleLeftFilled
};
